/* eslint-disable */ import { assertBoolean, assertString, attachSingleReferenceComponent, attributeSwitchComponent, memoEval, referenceComponent, textValueComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
import { PresetCategory } from '../admin-model/index.js';
export const presetComponents = [
    attachAdminComponent.withComponent(violationComponent, 'default', true).withEntity('Preset').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachSingleReferenceComponent(attachAdminComponent.withComponent(referenceComponent, 'Preset.$category', true).withEntity('Preset'), PresetCategory, 'categoryId'),
    attachAdminComponent.withComponent(textValueComponent, 'name', true).withEntity('Preset').attach(memoEval((self)=>[
            self.name
        ], (name)=>({
            value: name
        })), (state)=>{
        assertString(state.value);
        return {
            name: state.value
        };
    }),
    attachAdminComponent.withComponent(textValueComponent, 'description', true).withEntity('Preset').attach(memoEval((self)=>[
            self.description
        ], (description)=>({
            value: description
        })), (state)=>{
        assertString(state.value);
        return {
            description: state.value
        };
    }),
    attachAdminComponent.withComponent(attributeSwitchComponent, 'visible', true).withEntity('Preset').attach(memoEval((self)=>[
            self.visible
        ], (visible)=>({
            value: visible
        })), (state)=>{
        assertBoolean(state.value);
        return {
            visible: state.value
        };
    })
];

//# sourceMappingURL=preset.js.map